<div class="mapProject" *ngIf="!showSuccessMessage && (jiraIntegrationAvailable || agileStudioIntegrationAvailable)">
    <div class="mapProjectHeader">
        <div *ngIf="jiraIntegrationAvailable" class="option" [class.active]="activeTab === 'jira'"
            (click)="switchTab('jira')">Jira</div>
        <div *ngIf="agileStudioIntegrationAvailable" class="option" [class.active]="activeTab === 'agileStudio'"
            (click)="switchTab('agileStudio')">Agile Studio
        </div>
    </div>

    <div class="jira" *ngIf="activeTab === 'jira'">
        <h2>Import Jira Studio Project Artifacts</h2>
        <p>
            Getting started with your project setup is easy and flexible. We offer two import options designed to match
            your workflow — whether you're setting up a brand new project or updating an existing one. Choose between
            importing all available artifacts at once or handpicking the ones you need.
        </p>
        <div class="boxContainer">
            <label>Select Jira Project</label>
            <select [(ngModel)]="selectedProject" (change)="onProjectSelect()">
                <option value="" disabled selected>Select a project</option>
                <option *ngFor="let pmProject of PMProjectListJira" [ngValue]="pmProject">{{pmProject.projectName}}
                </option>
            </select>

        </div>
        <div class="myoption" *ngIf="isProjectSelected">
            <div class="fullImport">
                <div class="fullImportHeader">
                    <div class="checkbox">
                        <input type="radio" name="importType" [checked]="isFullImportChecked"
                            (change)="toggleFullImport()">
                        <h3>Full Import</h3>
                        <span class="material-symbols-rounded">
                            info
                        </span>
                    </div>
                    <p class="para">Automatically import all project artifacts in one go. Ideal for quickly setting up a
                        complete project
                        without manual selection.</p>
                </div>
                <div class="fullImportContent">
                </div>
            </div>
            <div class="selectiveImport">
                <div class="selectiveImportHeader">
                    <div class="checkbox">
                        <input type="radio" name="importType" [checked]="isSelectiveImportChecked"
                            (change)="toggleSelectiveImport()">
                        <h3>Selective Import</h3>
                        <span class="material-symbols-rounded">
                            info
                        </span>
                    </div>
                    <p class="para">Choose specific artifacts to import based on your needs. Perfect for customizing
                        your
                        project setup
                        and
                        avoiding unnecessary items.</p>
                </div>
                <div class="selectiveImportContent" *ngIf="isSelectiveImportChecked">
                    <div class="loading-container" *ngIf="isLoadingSelectiveData">
                        <div class="loading-spinner">
                            <i class="fas fa-spinner fa-spin"></i>
                            <span>Loading project data...</span>
                        </div>
                    </div>
                    <div *ngIf="!isLoadingSelectiveData">
                        <ul *ngFor="let epicList of selectiveEpic">
                            <li>
                                <input type="checkbox" [checked]="epicList.selected"
                                    (change)="onEpicCheckboxChange($event, epicList)" />
                                {{epicList._type}}: {{epicList.epic_name}}

                                <div id="childList">
                                    <ul>
                                        <li *ngFor="let child of epicList.children">
                                            <input type="checkbox" [checked]="child.selected"
                                                (change)="onChildCheckboxChange($event, child)" />
                                            {{child.issue_summary}}
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>

                        <ul *ngFor="let featureList of selectiveFeature">
                            <li><input type="checkbox"
                                    (change)="onFeatureCheckboxChange($event, featureList)">{{featureList.issue_type}}:
                                {{featureList.issue_summary}}
                                <div id="childList">
                                    <ul>
                                        <li *ngFor="let child of featureList.children"><input
                                                type="checkbox">{{child.issue_summary}}</li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                        <ul *ngFor="let scenarioList of selectiveScenario">
                            <li><input type="checkbox"
                                    (change)="onScenarioCheckboxChange($event, scenarioList)">{{scenarioList.issue_type}}:
                                {{scenarioList.issue_summary}}
                                <div id="childList">
                                    <ul>
                                        <li *ngFor="let child of scenarioList.children"><input
                                                type="checkbox">{{child.issue_summary}}</li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="agileStudio" *ngIf="activeTab === 'agileStudio'">
        <h2>Import Agile Studio Project Artifacts</h2>
        <p>
            Getting started with your project setup is easy and flexible. We offer two import options designed to match
            your workflow — whether you're setting up a brand new project or updating an existing one. Choose between
            importing all available artifacts at once or handpicking the ones you need.
        </p>
        <div class="boxContainer">
            <label>Select Agile Project</label>
            <select [(ngModel)]="selectedProject" (change)="onProjectSelect()">
                <option value="" disabled selected>Select a project</option>
                <option *ngFor="let pmProject of PMProjectListAgile" [ngValue]="pmProject">{{pmProject.projectName}}
                </option>
            </select>

        </div>
        <div class="myoption" *ngIf="isProjectSelected">
            <div class="fullImport">
                <div class="fullImportHeader">
                    <div class="checkbox">
                        <input type="radio" name="importType" [checked]="isFullImportChecked"
                            (change)="toggleFullImport()">
                        <h3>Full Import</h3>
                        <span class="material-symbols-rounded">
                            info
                        </span>
                    </div>
                    <p class="para">Automatically import all project artifacts in one go. Ideal for quickly setting up a
                        complete project
                        without manual selection.</p>
                </div>
                <div class="fullImportContent">
                </div>
            </div>
            <div class="selectiveImport">
                <div class="selectiveImportHeader">
                    <div class="checkbox">
                        <input type="radio" name="importType" [checked]="isSelectiveImportChecked"
                            (change)="toggleSelectiveImport()">
                        <h3>Selective Import</h3>
                        <span class="material-symbols-rounded">
                            info
                        </span>
                    </div>
                    <p class="para">Choose specific artifacts to import based on your needs. Perfect for customizing
                        your
                        project setup
                        and
                        avoiding unnecessary items.</p>
                </div>
                <div class="selectiveImportContent" *ngIf="isSelectiveImportChecked">
                    <div class="loading-container" *ngIf="isLoadingSelectiveData">
                        <div class="loading-spinner">
                            <i class="fas fa-spinner fa-spin"></i>
                            <span>Loading project data...</span>
                        </div>
                    </div>
                    <div *ngIf="!isLoadingSelectiveData">
                        <ul *ngFor="let epicList of selectiveEpic">
                            <li>
                                <input type="checkbox" [checked]="epicList.selected"
                                    (change)="onEpicCheckboxChange($event, epicList)" />
                                {{epicList._type}}: {{epicList.epic_name}}

                                <div id="childList">
                                    <ul>
                                        <li *ngFor="let child of epicList.children">
                                            <input type="checkbox" [checked]="child.selected"
                                                (change)="onChildCheckboxChange($event, child)" />
                                            {{child.issue_summary}}
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                        <ul *ngFor="let featureList of selectiveFeature">
                            <li><input type="checkbox"
                                    (change)="onFeatureCheckboxChange($event, featureList)">{{featureList.issue_type}}:
                                {{featureList.issue_summary}}
                                <div id="childList">
                                    <ul>
                                        <li *ngFor="let child of featureList.children"><input
                                                type="checkbox">{{child.issue_summary}}</li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                        <ul *ngFor="let scenarioList of selectiveScenario">
                            <li><input type="checkbox"
                                    (change)="onScenarioCheckboxChange($event, scenarioList)">{{scenarioList.issue_type}}:
                                {{scenarioList.issue_summary}}
                                <div id="childList">
                                    <ul>
                                        <li *ngFor="let child of scenarioList.children"><input
                                                type="checkbox">{{child.issue_summary}}</li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="mapProjectFooter">
        <button routerLink="/project">Previous</button>
        <button class="btn btn-primary" (click)="importAllMappedProject(selectedProject)"
            [disabled]="!isProjectSelected || isImporting" *ngIf="isFullImportChecked">
            <span *ngIf="!isImporting">Import</span>
            <span *ngIf="isImporting">
                <i class="fas fa-spinner fa-spin"></i> Importing...
            </span>
        </button>
        <button class="btn btn-primary" (click)="selectiveImport()" [disabled]="!isProjectSelected || isImporting"
            *ngIf="isSelectiveImportChecked">
            Import
        </button>
    </div>
</div>
<div class="successMessage" *ngIf="showSuccessMessage">
    <div class="project-details">
        <h3>Project Details</h3>
        <div class="project-info">
            <p><strong>Project Name:</strong> {{selectedProject?.projectName}}</p>
        </div>

        <div class="user-assignment">
            <h4>Assign Users</h4>
            <div class="user-list">
                <div *ngFor="let user of users" class="user-item">
                    <label>
                        <input type="checkbox" [checked]="isUserSelected(user)" (change)="onUserSelect(user)">
                        {{user}}
                    </label>
                </div>
            </div>

            <button class="btn btn-primary assign-btn" (click)="assignUsers()"
                [disabled]="!selectedProject || selectedUsers.length === 0 || isAssigning">
                <span *ngIf="!isAssigning">Assign Users</span>
                <span *ngIf="isAssigning">
                    <i class="fas fa-spinner fa-spin"></i> Assigning...
                </span>
            </button>
            <button class="btn btn-secondary skip-btn" (click)="skipAssignment()">
                Skip
            </button>
        </div>
    </div>
</div>